<template>
  <!--顶部菜单-->
  <div class="top_menu">
    <div :class="$parent.menuState?'titles':'title'" style="background: #F5F6F7">
      <img src="@/assets/logo.png" class="logo" alt="logo"  style="width: ;"/>
      <span v-if="!$parent.menuState">瑞银文件管理系统</span>
     </div>
    <ul>
      <li class="li_left" v-if="isAdmin">
        <i :class="$parent.menuState?'el-icon-s-unfold':'el-icon-s-fold'"
           @click="$parent.menuState=!$parent.menuState"></i>
      </li>
      <li>
        <user-pull-down>
          <span>   {{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i></span>
        </user-pull-down>

      </li>
    </ul>

  </div>
</template>

<script>
import * as c from '@/utils/config'
import * as u from '@/utils/util'

export default {
  name: "index",
  components: {
    'user-pull-down': () => import('@/components/auth/userPullDown.vue'),
  },
  data() {
    return {
      //用户信息
      userInfo: u.getSession(c.sessionKey.USER_INFO),
      isAdmin: false,
    }
  },
  mounted() {
       //判断是否是管理员角色
       this.isAdmin = this.userInfo.roles.includes("149");
   },
  methods: {


  }
}
</script>

<style scoped lang="scss">
.top_menu {
  width: 100%;
  height: 50px;
  display: flex; box-shadow: 0 0 4px rgba(0, 0, 0, 0.2); 
  // background: #001529;
 
  .logo {
          height: 40px;
          margin-top:5px ;
          vertical-align: top;
          margin-right: 8px;
         }

  .title {
    width: 226px;
    text-align: center;
    font-size: 18px;
    color: #363b4c;
    line-height: 50px;
    font-weight: 600;
   }

  .titles {
    width: 65px;
    text-align: center;
    font-size: 20px;
    color: #363b4c;
    line-height: 50px; 
    cursor: pointer;
  }

  ul {
    flex: 1;
    width: 100%;
    height: 100%;
    padding: 0 20px;
    color: #363b4c;
    list-style-type: none;
    text-align: right;
  }

  .li_left {
    float: left;
    margin-left: 0px;
    font-size: 20px;
    color: #363b4c;
   
   }

  .el-icon-s-fold:hover, .el-icon-s-unfold:hover {
    color: #169bd5;
  }

  li {
    line-height: 50px;
    margin-left: 20px;
  }
}
</style>
